import { ReactElement } from 'react';

import { Audit, Copy2, Create, Delete, Fail, Pass, Publish, Published, WithdrawIcon, WithdrawIcon2 } from '@/components/icon';
import { AuditStatusDetailType, AuditStatusType, BotAuditStatusDetailType } from '@/const/status';
import { PRIMARY_COLOR } from '@/const/style';

export const OPERATIONS: {
  value: string;
  label: string;
  icon: ReactElement;
  showStatus: AuditStatusType[];
  validate?: (publishedAt?: string) => boolean;
}[] = [
  {
    value: 'publish',
    label: '发布',
    icon: <Publish />,
    showStatus: [
      AuditStatusType.STATUS_TYPE_DEFAULT,
    ],
  },
  // {
  //   value: 'copy',
  //   label: '复制',
  //   icon: <Copy2 />,
  //   showStatus: [
  //     AuditStatusType.STATUS_TYPE_DEFAULT,
  //     AuditStatusType.STATUS_TYPE_MANUAL_ING,
  //     AuditStatusType.STATUS_TYPE_MANUAL_FAIL,
  //     AuditStatusType.STATUS_TYPE_MANUAL_PASS,
  //   ],
  // },
  {
    value: 'delete',
    label: '删除',
    icon: <Delete />,
    showStatus: [
      AuditStatusType.STATUS_TYPE_DEFAULT,
      AuditStatusType.STATUS_TYPE_MANUAL_FAIL,
    ],
    validate: (publishedAt?: string) => publishedAt === undefined,
  },
];

export const WOA_OPERATIONS: {
  value: string;
  label: string;
  icon: ReactElement;
  showStatus: AuditStatusDetailType[];
  validate?: (publishedAt?: string) => boolean
}[] = [
  {
    value: 'publish',
    label: '上架',
    icon: <Publish />,
    showStatus: [
      AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_PASS,
      AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_RESOURCE_PROCESS_FINISHED,
    ],
  },
  {
    value: 'audit',
    label: '审核',
    icon: <Audit />,
    showStatus: [
      AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_ING,
    ],
  },
  {
    value: 'withdraw',
    label: '下架',
    icon: <WithdrawIcon />,
    showStatus: [
      AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ONLINE,
    ],
  },
];

export const BOT_OPERATIONS: {
  value: string;
  label: string;
  icon: ReactElement;
  showStatus: AuditStatusType[];
  validate?: (visibility: number) => boolean
}[] = [
  {
    value: 'publish',
    label: '发布',
    icon: <Publish />,
    showStatus: [
      AuditStatusType.STATUS_TYPE_DEFAULT,
    ],
  },
  {
    value: 'copy',
    label: '复制',
    icon: <Copy2 />,
    showStatus: [
      AuditStatusType.STATUS_TYPE_DEFAULT,
      AuditStatusType.STATUS_TYPE_MANUAL_ING,
      AuditStatusType.STATUS_TYPE_MANUAL_FAIL,
      AuditStatusType.STATUS_TYPE_MANUAL_PASS,
    ],
  },
  {
    value: 'delete',
    label: '删除',
    icon: <Delete />,
    showStatus: [
      AuditStatusType.STATUS_TYPE_DEFAULT,
      AuditStatusType.STATUS_TYPE_MANUAL_FAIL,
    ],
    validate: (visibility: number) => visibility === 3,
  },
];

export const WOA_BOT_OPERATIONS: {
  value: string;
  label: string;
  icon: ReactElement;
  showStatus: AuditStatusType[];
  validate?: (visibility: number) => boolean
}[] = [
  // {
  //   value: 'copy',
  //   label: '复制',
  //   icon: <Copy2 />,
  //   showStatus: [
  //     AuditStatusType.STATUS_TYPE_DEFAULT,
  //     AuditStatusType.STATUS_TYPE_MANUAL_ING,
  //     AuditStatusType.STATUS_TYPE_MANUAL_FAIL,
  //     AuditStatusType.STATUS_TYPE_MANUAL_PASS,
  //   ],
  // },
  {
    value: 'withdraw',
    label: '下架',
    icon: <WithdrawIcon />,
    showStatus: [
      AuditStatusType.STATUS_TYPE_MANUAL_PASS,
    ],
  },
];

export const getAuditStatusIconMap = (release = false) => ({
  [AuditStatusType.STATUS_TYPE_DEFAULT]: {
    label: '创作中',
    color: PRIMARY_COLOR,
    icon: <Create />,
  },
  [AuditStatusType.STATUS_TYPE_MANUAL_ING]: {
    label: '审核中',
    color: 'rgba(123, 97, 255, 1)',
    icon: <Audit />,
  },
  [AuditStatusType.STATUS_TYPE_MANUAL_FAIL]: {
    label: '审核不通过',
    color: 'rgba(204, 73, 51, 1)',
    icon: <Fail />,
  },
  [AuditStatusType.STATUS_TYPE_MANUAL_PASS]: {
    label: release === true ? '已上架' : '审核通过',
    color: 'rgba(41, 167, 142, 1)',
    icon: <Published />,
  },
  [AuditStatusType.STATUS_TYPE_MANUAL_OFFLINE]: {
    label: '已下架',
    color: 'rgba(204, 73, 51, 1)',
    icon: <WithdrawIcon2 />,
  },
});

export const AUDIT_STATUS_ICON_CMS_MAP = {
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_DEFAULT]: {
    label: '创作中',
    color: PRIMARY_COLOR,
    icon: <Create />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ING]: {
    label: '安审中',
    color: 'rgba(123, 97, 255, 1)',
    icon: <Audit />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_PASS]: {
    label: '安审通过',
    color: 'rgba(51, 178, 108, 1)',
    icon: <Pass />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_FAIL]: {
    label: '安审不通过',
    color: 'rgba(204, 73, 51, 1)',
    icon: <Fail />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_ING]: {
    label: '复审中',
    color: 'rgba(123, 97, 255, 1)',
    icon: <Audit />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_FAIL]: {
    label: '复审不通过',
    color: 'rgba(204, 73, 51, 1)',
    icon: <Fail />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_REVIEW_PASS]: {
    label: '复审通过',
    color: 'rgba(51, 178, 108, 1)',
    icon: <Pass />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_RESOURCE_PROCESSING]: {
    label: '资源处理中',
    color: 'rgba(123, 97, 255, 1)',
    icon: <Pass />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_RESOURCE_PROCESS_FINISHED]: {
    label: '资源处理完成',
    color: 'rgba(51, 178, 108, 1)',
    icon: <Pass />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ONLINE]: {
    label: '已上架',
    color: 'rgba(41, 167, 142, 1)',
    icon: <Published />,
  },
  [AuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_OFFLINE]: {
    label: '已下架',
    color: 'rgba(204, 73, 51, 1)',
    icon: <WithdrawIcon2 />,
  },
};

export const BOT_AUDIT_STATUS_ICON_CMS_MAP = {
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_DEFAULT]: {
    label: '创作中',
    color: PRIMARY_COLOR,
    icon: <Create />,
  },
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ING]: {
    label: '安审中',
    color: 'rgba(123, 97, 255, 1)',
    icon: <Audit />,
  },
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_ONLINE]: {
    label: '已上架',
    color: 'rgba(41, 167, 142, 1)',
    icon: <Published />,
  },
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_FAIL]: {
    label: '安审不通过',
    color: 'rgba(204, 73, 51, 1)',
    icon: <Fail />,
  },
  [BotAuditStatusDetailType.STATUS_DETAIL_TYPE_MANUAL_OFFLINE]: {
    label: '已下架',
    color: 'rgba(204, 73, 51, 1)',
    icon: <WithdrawIcon2 />,
  },
};
